import { Chart } from "chart.js/auto";
import { useEffect, useRef } from "react";
import { AdminHomeSalesDto } from "../../types/dto/admin-home-sales-dto";

interface Props {
  data: AdminHomeSalesDto[];
}

export const AdminHomeSalesChart: React.FC<Props> = ({ data }) => {
  const chartRef = useRef<Chart | null>(null);

  useEffect(() => {
    const ctx = document.getElementById("myChart") as HTMLCanvasElement;

    // 기존 차트가 있을 경우 파괴
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    // 6개월 간의 매출 데이터를 가정 (실제 데이터로 교체)
    // const salesData = [1200, 1500, 1000, 2000, 1800, 2200]; // 매출 데이터
    const salesData = data.map((d) => {
      return d.totalSales;
    }); // 매출 데이터
    const labels = data.map((d) => {
      return `${d.month}월`;
    }); // 최근 6개월의 이름을 가져오는 함수

    // 새로운 차트를 생성하고 참조를 저장
    chartRef.current = new Chart(ctx, {
      type: "bar", // 막대 그래프
      data: {
        labels: labels, // x축 라벨
        datasets: [
          {
            label: "",
            data: salesData, // 실제 매출 데이터
            backgroundColor: [
              "#1A38601A",
              "#1A38601A",
              "#1A38601A",
              "#1A38601A",
              "#1A38601A",
              "#72ACA2",
            ],
            // barThickness: 53.33,
            // borderColor: "rgba(75, 192, 192, 1)", // 막대 테두리 색상
            // borderWidth: 1, // 막대 테두리 두께
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          x: {
            border: {
              width: 0,
            },
            // display: false, // y축 라벨 제거
            grid: {
              display: false, // x축 그리드 제거
              drawTicks: true,
              drawOnChartArea: false,
              //   drawBorder: false,
            },
            ticks: {
              display: true,
            },
          },
          y: {
            beginAtZero: true, // Y축이 0부터 시작하도록 설정
            grid: {
              display: false, // y축 그리드 제거
            },
            display: false, // y축 라벨 제거
            ticks: {
              display: false, // y축 라벨 제거
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    });

    // 컴포넌트 언마운트 시 차트를 파괴하여 메모리 누수 방지
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, []);

  return (
    <div className="w-[400px] h-[330px]">
      <canvas id="myChart"></canvas>
    </div>
  );
};
